module.exports = __webpack_public_path__ + "img/IMG_0079-1200w.2794a395.jpg";